import { defineRoute } from '../defineRoute';

export type HowDoesItWorkLandlordRouteParams = {
  // ...
};

export type HowDoesItWorkLandlordRouteParamsString = {
  // ...
};

export const HowDoesItWorkLandlord = defineRoute<
  HowDoesItWorkLandlordRouteParams,
  HowDoesItWorkLandlordRouteParamsString
>({
  pathname: '/landlord/how-does-it-work',
  nlPathname: '/verhuur/hoe-werkt-het',
  options: { isLandlordRoute: true, isPublic: true },
  routeParamsStringifier: () => {
    return {};
  },
  routeParamsParser: () => {
    return {};
  },
});
